﻿/*
 * Helper function for toggling hidden class
 */
export function toggleVisibility(el: JQuery<HTMLElement> | HTMLElement, override: boolean | null = null): void {
    const className = 'hidden';
    const $el = $(el);

    if (typeof override != 'undefined') {
        $el.toggleClass(className, !override);
    } else {
        $el.toggleClass(className);
    }
}

/*
 * Navigation hack, borrowed from bootstrap
 */
export function navFullscreen(state: boolean): void {
    const $body = $(document.body);

    $body.toggleClass('nav-open', state);
}

/**
 * Helper functio nto make an anchor tag a11y compatible
 */
export function a11yLink(el: HTMLAnchorElement, href: string, title?: string | null, target?: string | null): HTMLElement {
    el.href = href;

    if (title) {
        el.title = title;
        el.setAttribute('aria-label', title);
    }

    if (target) {
        el.target = target;
    }

    return el;
}

/**
 * Parses a string to text nodes and escapes newlines to <br> elements
 */
export function escapeText(text: string | null): Node[] {
    if (!text) {
        return [];
    }

    const lines = text.split('\n');

    return lines.reduce((acc, line, idx) => {
        acc.push(document.createTextNode(line));

        if (idx < (lines.length - 1)) {
            acc.push(document.createElement('br'));
        }

        return acc;
    }, [] as Node[]);
}

/**
 * Hyperscript like function for quickly creating elements, does only support className and not attributes/properties
 */
export function createElement<T extends HTMLElement = HTMLElement>(tagName: string, className?: string | null, ...children: (string | false | null | Node)[]): T {
    const $el = document.createElement(tagName) as T;

    if (className) {
        $el.className = className;
    }

    // Append child nodes
    if (children?.length) {
        children.forEach(child => {
            if (child != null && child !== false) {
                const node = typeof child == 'string'
                    ? document.createTextNode(child)
                    : child;

                $el.appendChild(node);
            }
        });
    }

    return $el;
}